module.exports = __webpack_public_path__ + "img/merge_type.de0ebd10.svg";